// @flow
// Features
import * as React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import {
  decodeToken,
  decodeBody,
  rotationsGroupedByInstitutions,
} from "./review/_EvaluationsReView.utils";
import { PublicEvaluations } from "../../actions/actions";
// Components
import PublicEvaluationView from "./PublicEvaluations.view";
// Types
type Props = {
  config: Object,
  token: string,
  getPublicEvaluationDatas: (payload: Object) => void,
  goTo: (payload: any) => void,
  url: "evaluations",
};
type State = {
  component: ?React.ElementType,
  evaluation: ?Object,
  errorPublicEvaluation: string,
  fetchingDatas: boolean,
  showPublicEvaluation: boolean,
  tenant: string,
  apiToken: string,
};
class PublicEvaluationContainer extends React.Component<Props, State> {
  // Privates properties:
  _isMounted = false;
  // Public properties:
  state = {
    component: null,
    evaluation: null,
    errorPublicEvaluation: "",
    fetchingDatas: true,
    showPublicEvaluation: false,
    tenant: "",
    apiToken: "",
  };
  // <Mounting Component>
  componentDidMount() {
    this._isMounted = true;
    this._onGetPublicEvaluationDatas();
  }
  // <Mounting Component>
  // <GET_PUBLIC_EVALUATION>
  _onGetPublicEvaluationDatas = () => {
    const onEndCallback = () => {
      this.setState({ fetchingDatas: false });
    };
    const { goTo } = this.props;
    this._onGettingPublicEvaluationDatas()
      .then(onEndCallback)
      .catch(() => {
        onEndCallback();
        // setTimeout(() => {
        //   goTo("/");
        // }, 10000);
      });
  };
  _onGettingPublicEvaluationDatas = () => {
    const { token, getPublicEvaluationDatas } = this.props;
    const { body: apiToken } = decodeToken(token);
    const {
      scheduler: evaluationSchedulerId,
      target,
      tenant,
      trigger,
    } = decodeBody(apiToken);
    this.setState({ tenant, apiToken });
    return new Promise((resolve, reject) => {
      const formValues = {
        evaluationSchedulerId,
        hasGetApiRotationsOrTargets: !target,
        token,
        trigger,
      };
      const callbacks = {
        callbackError: (errorPublicEvaluation) => {
          window.logger.log(
            "PublicEvaluation - error - _onGettingPublicEvaluationDatas",
            token,
            errorPublicEvaluation
          );
          this.setState({ errorPublicEvaluation });
          reject();
        },
        callbackSuccess: (data: Object, dataTargets: Object[]) => {
          window.logger.log(
            "PublicEvaluation - success - _onGettingPublicEvaluationDatas",
            data,
            dataTargets
          );
          const { evaluation: evaluationData } = data;
          let evaluation = { ...evaluationData };
          if (
            evaluation &&
            evaluation.isPublic &&
            evaluation.evaluationType === "PublicEvaluations" &&
            evaluation.evaluatorsRole === "NoRegisteredUser" &&
            evaluation.status !== "closed"
          ) {
            const { publicEvaluator, publicEvaluatorsAvailable } = evaluation;
            const [publicEvaluatorAvailable] = publicEvaluatorsAvailable;
            evaluation = {
              ...evaluation,
              canSubmit: true,
              evaluator: publicEvaluator || publicEvaluatorAvailable,
              institutions: [],
              trigger,
            };
            if (trigger !== "custom_period") {
              const { rotations } = dataTargets;
              const institutions = rotationsGroupedByInstitutions(
                rotations || []
              );
              console.log("institutions", institutions);
              evaluation = {
                ...evaluation,
                institutions,
              };
            } else {
              const { targets } = dataTargets;
              console.log("targets", targets);
              evaluation = {
                ...evaluation,
                targets,
              };
            }
            this.setState({ evaluation });
            this._loadingComponent(resolve);
          } else {
            this.setState({
              errorPublicEvaluation:
                "Evaluation has been closed. If the problem persist, check with your school administrator.",
            });
            reject();
          }
        },
      };
      const payload = Object.assign({}, formValues, callbacks);
      getPublicEvaluationDatas(payload);
    });
  };
  // </GET_PUBLIC_EVALUATION>
  // <METHODS_PRIVATES>
  _loadingComponent = (resolve: () => void) => {
    const { url } = this.props;
    let componentType = url
      .split("-")
      .map(
        (partialUrlName) =>
          partialUrlName.charAt(0).toUpperCase() + partialUrlName.slice(1)
      )
      .join("");
    window.logger.log("_loadingComponent", url, componentType);
    (async () => {
      const component = await import(
        `./review/${componentType}ReView.container`
      );
      this.setState({
        component: component.default,
      });
      setTimeout(() => {
        this.setState({ showPublicEvaluation: true });
        resolve();
      }, 500);
    })();
  };
  // </METHODS_PRIVATES>
  // <RENDERS>
  render() {
    const {
      fetchingDatas,
      errorPublicEvaluation,
      component: EvaluationsReViewContainer,
      showPublicEvaluation,
      ...remainState
    } = this.state;
    if (!showPublicEvaluation) {
      return (
        <PublicEvaluationView
          checkingPublicEvaluation={fetchingDatas}
          errorPublicEvaluation={
            errorPublicEvaluation || "Error Public Evaluation"
          }
        />
      );
    }

    return (
      EvaluationsReViewContainer && (
        <EvaluationsReViewContainer {...remainState} token={this.props.token} />
      )
    );
  }
  // </RENDERS>
  // <Updating Component>
  // </Updating Component>
  componentWillUnmount() {
    this._isMounted = false;
  }
}
export default connect(null, (dispatch) => ({
  getPublicEvaluationDatas: (payload) =>
    dispatch(PublicEvaluations.publicEvaluationFetch(payload)),
  goTo: (path) => dispatch(push(path)),
}))(PublicEvaluationContainer);
